var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.all > 0)?_c('h3',[_vm._v("Progress: "+_vm._s(Math.round(_vm.finished / _vm.all * 100))+"%")]):_c('h3',[_vm._v("Progress: N/A")]),_c('b-progress',{attrs:{"value":Math.round(_vm.finished / _vm.all * 100),"max":100}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }